const widgetSelector =
  "#apps-section .jdgm-widget[data-widget='review'], #apps-section #judgeme_product_reviews";
const nativeControlSelector = "a, button, input, select, textarea";
const starCharacter = String.fromCharCode(9733);
const verifiedIconMarkup = `
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.8 9.70156C18.8 10.5016 17.6 11.1016 17.4 11.8016C17.2 12.5016 17.9 13.7016 17.6 14.3016C17.2 15.0016 15.9 14.9016 15.4 15.4016C14.9 15.9016 14.9 17.3016 14.3 17.6016C13.7 18.0016 12.5 17.2016 11.8 17.4016C11.1 17.6016 10.5 18.8016 9.7 18.8016C8.9 18.8016 8.3 17.6016 7.6 17.4016C6.9 17.2016 5.7 17.9016 5.1 17.6016C4.4 17.2016 4.5 15.9016 4 15.4016C3.5 14.9016 2.1 14.9016 1.8 14.3016C1.4 13.7016 2.2 12.5016 2 11.8016C1.7 11.0016 0.5 10.4016 0.5 9.70156C0.5 8.90156 1.7 8.30156 1.9 7.60156C2.1 6.90156 1.4 5.70156 1.7 5.10156C2.1 4.40156 3.4 4.50156 4 4.00156C4.5 3.50156 4.5 2.10156 5.1 1.80156C5.7 1.40156 6.9 2.20156 7.6 2.00156C8.3 1.80156 8.9 0.601562 9.7 0.601562C10.5 0.601562 11.1 1.80156 11.8 2.00156C12.5 2.20156 13.7 1.50156 14.3 1.80156C15 2.20156 14.9 3.50156 15.4 4.00156C15.9 4.50156 17.3 4.50156 17.6 5.10156C18 5.70156 17.2 6.90156 17.4 7.60156C17.6 8.30156 18.8 8.90156 18.8 9.70156Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.39995 13.3031C8.09995 13.3031 7.79995 13.2031 7.59995 13.0031L4.99995 10.4031C4.59995 10.0031 4.59995 9.30312 4.99995 8.90312C5.39995 8.50312 6.09995 8.50312 6.49995 8.90312L8.29995 10.7031L12.5 6.50313C12.9 6.10313 13.6 6.10313 14 6.50313C14.4 6.90313 14.4 7.60312 14 8.00312L8.99995 13.0031C8.99995 13.1031 8.69995 13.3031 8.39995 13.3031Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

initJudgeMeReviews();
document.addEventListener("shopify:section:load", (event) =>
  initJudgeMeReviews(event.target)
);

function initJudgeMeReviews(root = document) {
  const widgets = root.querySelectorAll(widgetSelector);

  widgets.forEach((widget) => {
    if (widget.dataset.kbJudgemeInitialized === "true") return;

    widget.dataset.kbJudgemeInitialized = "true";

    waitForWidgetData(widget, (data) => {
      if (!data) {
        widget.dataset.kbJudgemeInitialized = "false";
        return;
      }

      const view = createReviewView(widget);
      const state = {
        loadedReviewIds: new Set(),
        mode: "replace",
        renderTimer: null,
        fallbackTimer: null,
      };

      hideNativeWidget(widget);
      renderReviewView(view, widget, data, state);
      bindReviewView(view, widget, state);
      observeNativeWidget(view, widget, state);
    });
  });
}

function waitForWidgetData(widget, callback, attempts = 0) {
  const data = getWidgetData(widget);

  if (data) {
    callback(data);
    return;
  }

  if (attempts >= 40) {
    callback(null);
    return;
  }

  window.setTimeout(
    () => waitForWidgetData(widget, callback, attempts + 1),
    125
  );
}

function getWidgetData(widget) {
  const productId = widget.dataset.productId || widget.dataset.id;

  const widgetData = productId
    ? window.jdgm?.data?.reviewWidget?.[productId]
    : null;

  if (widgetData) return widgetData;

  const nativeReviews = getNativeReviews(widget);

  if (!nativeReviews.length) return null;

  return {
    average_rating: getNativeAverageRating(widget, nativeReviews),
    number_of_reviews: getNativeReviewCount(widget, nativeReviews),
    reviews: nativeReviews,
  };
}

function createReviewView(widget) {
  const existingView = widget.previousElementSibling;

  if (existingView?.classList.contains("c-judgeme-reviews")) {
    return existingView;
  }

  const view = document.createElement("section");
  view.className = "c-judgeme-reviews";
  view.id = "judgeme-theme-reviews";
  view.setAttribute("aria-label", "Customer reviews");
  view.innerHTML = `
    <div class="c-judgeme-reviews__inner">
      <p class="c-judgeme-reviews__eyebrow">Verified reviews</p>
      <h2 class="c-judgeme-reviews__heading">See what our customers have to say.</h2>
      <div class="c-judgeme-reviews__toolbar">
        <div class="c-judgeme-reviews__summary" data-jdgm-theme-summary></div>
        <div class="c-judgeme-reviews__actions">
          <button class="c-judgeme-reviews__button" type="button" data-jdgm-theme-write>
            Write a review
          </button>
          <label class="c-judgeme-reviews__sort">
            <span class="is-visibly-hidden">Sort reviews by</span>
            <select class="c-judgeme-reviews__sort-select" data-jdgm-theme-sort aria-label="Sort reviews by"></select>
          </label>
        </div>
      </div>
      <div class="c-judgeme-reviews__list" data-jdgm-theme-list></div>
      <button class="c-judgeme-reviews__more" type="button" data-jdgm-theme-more>
        Show more reviews
      </button>
    </div>
  `;

  widget.before(view);

  return view;
}

function hideNativeWidget(widget) {
  widget.classList.add("is-kb-judgeme-source");
  widget.setAttribute("aria-hidden", "true");
  unfocusNativeControls(widget);
}

function unfocusNativeControls(widget) {
  widget.querySelectorAll(nativeControlSelector).forEach((control) => {
    control.tabIndex = -1;
  });
}

function bindReviewView(view, widget, state) {
  view
    .querySelector("[data-jdgm-theme-write]")
    ?.addEventListener("click", () => {
      getNativeWriteButton(widget)?.click();
    });

  view
    .querySelector("[data-jdgm-theme-sort]")
    ?.addEventListener("change", (event) => {
      const nativeSelect = getNativeSortSelect(widget);

      if (!nativeSelect) return;

      nativeSelect.value = event.target.value;
      state.mode = "replace";
      state.loadedReviewIds.clear();
      nativeSelect.dispatchEvent(new Event("input", { bubbles: true }));
      nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));
      queueNativeRender(view, widget, state);
    });

  view
    .querySelector("[data-jdgm-theme-more]")
    ?.addEventListener("click", (event) => {
      const nextButton = getNativeNextButton(widget);

      if (!nextButton) return;

      event.currentTarget.disabled = true;
      state.mode = "append";
      preserveScrollPosition(() => nextButton.click());
      queueNativeRender(view, widget, state);
    });
}

function preserveScrollPosition(callback) {
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;
  const restore = () => window.scrollTo(scrollX, scrollY);

  callback();
  restore();
  window.requestAnimationFrame(restore);
  window.setTimeout(restore, 125);
  window.setTimeout(restore, 500);
}

function observeNativeWidget(view, widget, state) {
  const observer = new MutationObserver(() => {
    window.clearTimeout(state.renderTimer);
    state.renderTimer = window.setTimeout(() => {
      const data = getWidgetData(widget);

      unfocusNativeControls(widget);

      if (data) renderReviewView(view, widget, data, state);
    }, 125);
  });

  observer.observe(widget, {
    childList: true,
    subtree: true,
  });
}

function renderReviewView(view, widget, data, state) {
  const renderData = getRenderableData(widget, data);

  renderSummary(view, renderData);
  renderSortOptions(view, widget);
  renderReviews(view, renderData, state);
  renderShowMore(view, widget);
}

function renderSummary(view, data) {
  const summary = view.querySelector("[data-jdgm-theme-summary]");
  const average = formatAverage(data.average_rating);
  const count = Number(data.number_of_reviews || 0);
  const reviewLabel = count === 1 ? "review" : "reviews";

  summary.innerHTML = "";
  summary.append(
    createElement("span", "c-judgeme-reviews__average", average),
    createElement(
      "span",
      "c-judgeme-reviews__summary-stars",
      starCharacter.repeat(5)
    ),
    createElement(
      "span",
      "c-judgeme-reviews__count",
      `(${count} ${reviewLabel})`
    )
  );
}

function renderSortOptions(view, widget) {
  const sortSelect = view.querySelector("[data-jdgm-theme-sort]");
  const nativeSelect = getNativeSortSelect(widget);
  const nativeOptions = nativeSelect ? [...nativeSelect.options] : [];

  if (!sortSelect || sortSelect.dataset.kbOptionsReady === "true") return;

  const options = nativeOptions.length
    ? nativeOptions.map((option) => ({
        label: option.textContent.trim(),
        value: option.value,
      }))
    : [
        { label: "Most recent", value: "created_at" },
        { label: "Highest rating", value: "highest_rating" },
        { label: "Lowest rating", value: "lowest_rating" },
        { label: "Only pictures", value: "with_pictures" },
        { label: "Pictures first", value: "pictures_first" },
        { label: "Videos first", value: "videos_first" },
        { label: "Most helpful", value: "most_helpful" },
      ];

  sortSelect.innerHTML = options
    .map(
      (option) =>
        `<option value="${escapeAttribute(option.value)}">${escapeHTML(
          option.label
        )}</option>`
    )
    .join("");
  sortSelect.value = nativeSelect?.value || options[0]?.value || "created_at";
  sortSelect.dataset.kbOptionsReady = "true";
}

function renderReviews(view, data, state) {
  const list = view.querySelector("[data-jdgm-theme-list]");
  const reviews = Array.isArray(data.reviews) ? data.reviews : [];

  if (state.mode === "append") {
    let appendedCount = 0;

    reviews.forEach((review) => {
      const id = getReviewId(review);

      if (state.loadedReviewIds.has(id)) return;

      state.loadedReviewIds.add(id);
      list.append(createReviewCard(review));
      appendedCount += 1;
    });

    if (appendedCount > 0) {
      state.mode = "replace";
    }

    return;
  }

  list.innerHTML = "";
  state.loadedReviewIds.clear();

  reviews.forEach((review) => {
    const id = getReviewId(review);

    if (state.loadedReviewIds.has(id)) return;

    state.loadedReviewIds.add(id);
    list.append(createReviewCard(review));
  });

  state.mode = "replace";
}

function createReviewCard(review) {
  const card = document.createElement("article");
  const title = review.title?.trim();
  const body = review.body?.trim() || stripHTML(review.body_html || "");
  const reviewerName = review.reviewer_name || "Anonymous";

  card.className = `c-judgeme-reviews__card${
    title ? "" : " c-judgeme-reviews__card--no-title"
  }`;
  card.innerHTML = `
    <header class="c-judgeme-reviews__card-header">
      <span class="c-judgeme-reviews__reviewer">${escapeHTML(
        reviewerName
      )}</span>
      <span class="c-judgeme-reviews__stars" aria-label="${escapeAttribute(
        review.rating || 0
      )} out of 5 stars">
        ${starCharacter.repeat(Math.max(0, Number(review.rating || 0)))}
      </span>
      <time class="c-judgeme-reviews__date" datetime="${escapeAttribute(
        formatMachineDate(review.created_at)
      )}">
        ${escapeHTML(review.date_label || formatReviewDate(review.created_at))}
      </time>
    </header>
    <div class="c-judgeme-reviews__card-body">
      <div class="c-judgeme-reviews__verified-wrap">
        ${
          isVerifiedReview(review)
            ? `<p class="c-judgeme-reviews__verified"><span class="c-judgeme-reviews__verified-icon" aria-hidden="true">${verifiedIconMarkup}</span>Verified buyer</p>`
            : ""
        }
      </div>
      <div class="c-judgeme-reviews__content">
        ${
          body
            ? `<p class="c-judgeme-reviews__body">${escapeHTML(body)}</p>`
            : ""
        }
      </div>
    </div>
  `;

  return card;
}


// ${title ? `<h3 class="c-judgeme-reviews__title">${escapeHTML(title)}</h3>` : "" }

function renderShowMore(view, widget) {
  const button = view.querySelector("[data-jdgm-theme-more]");
  const hasNativeNext = Boolean(getNativeNextButton(widget));

  button.hidden = !hasNativeNext;
  button.disabled = false;
}

function queueNativeRender(view, widget, state) {
  window.clearTimeout(state.fallbackTimer);

  state.fallbackTimer = window.setTimeout(() => {
    const data = getWidgetData(widget);

    unfocusNativeControls(widget);

    if (data) renderReviewView(view, widget, data, state);
  }, 900);
}

function getRenderableData(widget, data) {
  const nativeReviews = getNativeReviews(widget);

  if (!nativeReviews.length) return data;

  return {
    ...data,
    reviews: nativeReviews,
  };
}

function getNativeReviews(widget) {
  return [...widget.querySelectorAll(".jm-review-item")]
    .map(parseNativeReview)
    .filter((review) => review.reviewer_name || review.body);
}

function getNativeAverageRating(widget, reviews) {
  const averageText = getText(
    widget,
    ".jdgm-rev-widg__summary-average, .jm-reviews-widget__summary-average"
  );
  const averageMatch = averageText.match(/[\d.]+/);

  if (averageMatch) return Number(averageMatch[0]);

  const ratings = reviews
    .map((review) => Number(review.rating || 0))
    .filter((rating) => rating > 0);

  if (!ratings.length) return 0;

  return ratings.reduce((total, rating) => total + rating, 0) / ratings.length;
}

function getNativeReviewCount(widget, reviews) {
  const countCandidates = [
    getText(widget, ".jdgm-rev-widg__summary-text"),
    getText(widget, ".jm-reviews-widget__summary-text"),
    getText(widget, ".jm-tabs__tab--active"),
    getText(widget, ".jm-reviews-widget__reviews-list-title"),
    widget.textContent || "",
  ];

  for (const text of countCandidates) {
    const parentheticalMatch = text.match(/\(([\d,]+)\)/);

    if (parentheticalMatch) {
      return Number(parentheticalMatch[1].replace(/,/g, ""));
    }

    const reviewMatch = text.match(/([\d,]+)\s+reviews?/i);

    if (reviewMatch) return Number(reviewMatch[1].replace(/,/g, ""));
  }

  return reviews.length;
}

function parseNativeReview(item) {
  const ratingLabel =
    item.querySelector(".jm-star-rating")?.getAttribute("aria-label") || "";
  const ratingMatch = ratingLabel.match(/([\d.]+)\s+out\s+of\s+5/i);
  const dateText = getNativeReviewDate(item);

  return {
    uuid: item.getAttribute("review-uuid") || "",
    title: getText(
      item,
      ".jm-review-content__title, .jdgm-review-content__title"
    ),
    rating: ratingMatch
      ? Number(ratingMatch[1])
      : item.querySelectorAll(".jm-star-rating__font-icon").length,
    body: getText(
      item,
      ".jdgm-review-content__body-content, .jm-review-content__body"
    ),
    reviewer_name: getText(item, ".jm-reviewer-info__name") || "Anonymous",
    created_at: parseNativeDate(dateText),
    date_label: dateText ? formatReviewDate(parseNativeDate(dateText)) : "",
    verified_buyer: Boolean(item.querySelector(".jm-verified-by-shop-badge")),
    transparency_badges: getText(item, ".jm-transparency-badge-list")
      ? ["review_written_in_shop_app"]
      : [],
  };
}

function getNativeReviewDate(item) {
  const candidates = [
    ...item.querySelectorAll(
      ".jm-reviewer-info__details .jm-text, .jm-reviewer-info .jm-text"
    ),
  ].map((element) => normalizeText(element.textContent));

  return (
    candidates.find((text) => /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(text)) || ""
  );
}

function getText(root, selector) {
  return normalizeText(root.querySelector(selector)?.textContent || "");
}

function normalizeText(value) {
  return String(value).replace(/\s+/g, " ").trim();
}

function getReviewId(review) {
  return (
    review.uuid ||
    `${review.reviewer_name || ""}-${review.created_at || ""}-${
      review.body || ""
    }`
  );
}

function getNativeWriteButton(widget) {
  return (
    widget.querySelector('[data-testid="write-review-button"]') ||
    widget.querySelector(".jm-action-buttons__button")
  );
}

function getNativeSortSelect(widget) {
  return widget.querySelector(".jdgm-sort-dropdown, .jm-sort-filter__select");
}

function getNativeNextButton(widget) {
  return (
    widget.querySelector(
      '.jm-pagination-controls__button[aria-label="Go to next page"]:not([disabled])'
    ) ||
    [
      ...widget.querySelectorAll(
        ".jm-pagination-controls__button--nav:not([disabled])"
      ),
    ].pop()
  );
}

function createElement(tag, className, text) {
  const element = document.createElement(tag);
  element.className = className;
  element.textContent = text;

  return element;
}

function formatAverage(value) {
  const average = Number(value || 0);

  if (!Number.isFinite(average)) return "0.0";

  return average.toFixed(1);
}

function formatReviewDate(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
    .format(date)
    .replace(".", "")
    .toUpperCase();
}

function formatMachineDate(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toISOString().split("T")[0];
}

function parseNativeDate(value) {
  const match = String(value || "").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

  if (!match) return value || "";

  const [, month, day, year] = match;

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T00:00:00`;
}

function isVerifiedReview(review) {
  return (
    review.verified_buyer ||
    review.transparency_badges?.includes("review_written_in_shop_app")
  );
}

function stripHTML(value) {
  const element = document.createElement("div");
  element.innerHTML = value;

  return element.textContent || "";
}

function escapeHTML(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function escapeAttribute(value) {
  return escapeHTML(value);
}
